import React from 'react';
import { formatCurrency } from 'util/formatters';

const DisplayAmount = ({
  className = '',
  amount = 0,
  useMoneySign = false,
  disabledColor = false,
  loading
}) => {
  if (loading) {
    return <span className="skeleton-loader-gradient" />;
  }

  let classNames = ['gx-text-wrap-nowrap'];

  if (className) {
    classNames = [className];
  }

  if (!disabledColor && amount > 0) {
    classNames.push('gx-displayamount-positive');
  }

  if (!disabledColor && amount < 0) {
    classNames.push('gx-displayamount-negative');
  }

  return (
    <span className={classNames.join(' ')}>
      {formatCurrency(amount, useMoneySign)}
    </span>
  );
};

export default DisplayAmount;
